import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectAuthenticated } from '../Login/selectors';

/** There is nothing to show on its own at the root: players go to their games, or to log in. */
const Home = () => {
  const authenticated = useSelector(selectAuthenticated);

  return <Navigate to={authenticated ? '/games' : '/login'} replace />;
};

export default Home;
